import React from "react";
import { Snowflake } from "lucide-react";

// Red follow-up badge — flashes next to the realtor's name whenever they
// have logged at least one referral AND we haven't contacted them within
// the user-selected threshold. Silent otherwise so the row stays clean.
export default function NeedsFollowUpBadge({ row }) {
  if (!row?.needs_follow_up) return null;
  const days = row.days_since_contact;
  const label = days == null
    ? "No contact"
    : days >= 365
      ? `${Math.floor(days / 365)}y overdue`
      : days >= 30
        ? `${Math.floor(days / 30)}mo overdue`
        : `${days}d overdue`;
  return (
    <span
      title={
        row.referral_count > 0
          ? `${row.referral_count} past referral${row.referral_count === 1 ? "" : "s"} — reconnect before they refer your competition`
          : "This realtor has referred a client but you haven't logged any follow-up yet"
      }
      className="inline-flex items-center justify-center gap-1 shrink-0 rounded-2xl border border-rose-200 bg-rose-100 text-rose-700 text-[10px] font-semibold uppercase tracking-wide leading-tight text-center whitespace-normal break-words max-w-[4.5rem] px-2 py-1"
      data-testid={`outreach-follow-up-badge-${row.id}`}
    >
      <Snowflake className="h-3 w-3 shrink-0" />
      {label}
    </span>
  );
}
